import Footer from '../components/Footer'
import MatrimonyHeader from '../components/MatrimonyHeader'
import MatriMyProfileHero from "../components/MatriMyProfileHero"
import MatriSetting from '../components/MatriSetting'
import React from 'react'

function Setting() {
  return (
    <div>
        <MatrimonyHeader />
        <MatriMyProfileHero />
        <MatriSetting />
        <Footer />
    </div>
  )
}

export default Setting